var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_c('div',{staticClass:"row"},[_c('Form',{staticClass:"no-print col-12 col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[_c('div',{staticClass:"row"},[_c('Contract',{staticClass:"col-12"})],1)]),_vm._v(" "),_c('ButtonBar',{staticClass:"no-print col-12",attrs:{"docxIsVisible":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/hemmelig/App.vue?vue&type=template&id=2acfc2ca&
// module id = null
// module chunks = 